module.exports = __webpack_public_path__ + "resources/img/img_cloudz_modernization_m.22f7eee71987b5fd02ca66aa9000612c.png";